
    const data = {"name":"src/core/icons/rectangle-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M4 6v13h16V6H4m14 11H6V8h12v9Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            